import * as React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import Rating from "@mui/material/Rating";
import Slider from "@mui/material/Slider";
import { emojiIcons, marks, thumbsIcon } from "./common";
import "./style.scss";

const StyledRating = styled(Rating)(({ theme }) => ({}));

function IconContainer(props) {
  const { value, type, ...other } = props;
  const iconSet = type === "emoji" ? emojiIcons : thumbsIcon;
  return <span {...other}>{iconSet[value].icon}</span>;
}

IconContainer.propTypes = {
  value: PropTypes.number.isRequired,
};

const EmojiRating = ({ mock, name, maintainValues, setMaintainValues }) => {
  const iconType = mock?.ratingSettings?.ratingType;
  const iconSet = iconType === "emoji" ? emojiIcons : thumbsIcon;

  const getRatingValue = (value) => {
    if (iconType === "emoji") {
      if (typeof value === "number") {
        switch (value) {
          case 1:
            return "Not-satisfied";
          case 2:
            return "Neutral";
          case 3:
            return "Satisfied";
          default:
            return null;
        }
      } else {
        switch (value) {
          case "Not-satisfied":
            return 1;
          case "Neutral":
            return 2;
          case "Satisfied":
            return 3;
          default:
            return null;
        }
      }
    } else {
      if (typeof value === "number") {
        switch (value) {
          case 1:
            return "Satisfied";
          case 2:
            return "Not-satisfied";
          default:
            return null;
        }
      } else {
        switch (value) {
          case "Satisfied":
            return 1;
          case "Not-satisfied":
            return 2;
          default:
            return null;
        }
      }
    }
  };

  return (
    <>
      {["emoji", "thumbs"].includes(iconType) ? (
        <StyledRating
          name="highlight-selected-only"
          className="styled-rating"
          max={iconType === "emoji" ? 3 : 2}
          IconContainerComponent={(props) =>
            IconContainer({ ...props, type: iconType })
          }
          getLabelText={(value) => iconSet[value].label}
          highlightSelectedOnly
          defaultValue={getRatingValue(maintainValues[`${name}`])}
          value={getRatingValue(maintainValues[`${name}`])}
          onChange={(_, value) => {
            setMaintainValues({
              ...maintainValues,
              [`${name}`]: getRatingValue(value),
            });
          }}
        />
      ) : iconType === "slider" ? (
        <Slider
          className="Slider-Rating-container"
          defaultValue={maintainValues[`${name}`] || 0}
          step={10}
          valueLabelDisplay="auto"
          marks={marks}
          value={maintainValues[`${name}`]}
          onChange={(_, val) => {
            setMaintainValues({
              ...maintainValues,
              [`${name}`]: val,
            });
          }}
        />
      ) : (
        <></>
      )}
    </>
  );
};

export default EmojiRating;
